import useHandleServerErrors from "hooks/useHandleServerErrors"
import {
  editActivityNoteSchema,
  useUpdateActivityNote
} from "entities/activity-note"
import { closeDialog } from "./store"

export const useHandleUpdateActivityNote = (id) => {
  const updateActivityNote = useUpdateActivityNote()
  const handleServerErrors = useHandleServerErrors()

  return (values, formik) => {
    updateActivityNote.mutate(editActivityNoteSchema.cast({ id, ...values }), {
      onSuccess() {
        formik.resetForm()
        closeDialog()
      },
      onError: (error) => handleServerErrors(error),
      onSettled() {
        formik.setSubmitting(false)
      }
    })
  }
}
